import React from 'react';
import {observable, action, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import store from '../../s';
import {checkout} from '../../../api';
import {hideAllModals} from '../../../util';

interface ILineCustomProps {
    id: number;
    modalId: string;
}

@observer
class ModalInfo extends React.Component<ILineCustomProps> {
    @observable c1: string;
    @observable c1t: string;
    @observable c2: string;
    @observable c2t: string;
    @observable c3: string;
    @observable c3t: string;

    constructor(props) {
        super(props);
        this.setup = this.setup.bind(this);
        this.save = this.save.bind(this);
        this.setup();
        makeObservable(this);
    }

    @action
    setup = () => {
        const item = store.checkout.cart.items.filter(o => o.id === this.props.id)[0];
        this.c1 = item.CustomField1;
        this.c2 = item.CustomField2;
        this.c3 = item.CustomField3;
        this.c1t = item.CustomField1_Title;
        this.c2t = item.CustomField2_Title;
        this.c3t = item.CustomField3_Title;
    };

    @action
    save = async (e: any) => {
        const item = store.checkout.cart.items.filter(o => o.id === this.props.id)[0];
        item.CustomField1 = this.c1;
        item.CustomField2 = this.c2;
        item.CustomField3 = this.c3;
        item.CustomField1_Title = this.c1t;
        item.CustomField2_Title = this.c2t;
        item.CustomField3_Title = this.c3t;
        const success = await checkout('line-custom-save');
        hideAllModals();
    };

    render() {
        return (
            <div
                className="modal fade"
                tabIndex={-1}
                role="dialog"
                id={this.props.modalId}
            >
                <div
                    className="modal-dialog"
                    role="document"
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Edit product custom fields</h4>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {this.c1t.length && this.c1t.trim().length > 0 && (
                                <div>
                                    <div className="form-label">{this.c1t}</div>
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={this.c1}
                                            onChange={e => (this.c1 = e.target.value)}
                                            maxLength={30}
                                        />
                                    </div>
                                </div>
                            )}
                            {this.c2t.length && this.c2t.trim().length > 0 && (
                                <div>
                                    <div className="form-label pad-top-2x">{this.c2t}</div>
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={this.c2}
                                            onChange={e => (this.c2 = e.target.value)}
                                            maxLength={30}
                                        />
                                    </div>
                                </div>
                            )}
                            {this.c3t.length && this.c3t.trim().length > 0 && (
                                <div>
                                    <div className="form-label pad-top-2x">{this.c3t}</div>
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={this.c3}
                                            onChange={e => (this.c3 = e.target.value)}
                                            maxLength={30}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-light"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={this.save}
                                aria-label="Save fields"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default ModalInfo;
